export default __webpack_public_path__ + "static/hero-7-bf88c6d05d9e6e6f34bc5c208f5f7957.webp";